import $ from "jquery";
window.$ = window.jQuery = $;

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
window.dispatchEvent(new Event("bootstrap-ready"));

//import { createApp } from 'vue';
//import App from './vue/app.vue';

//createApp(App).mount('#MyApp');

import { initMegaMenu } from "./components/mega-menu";
import { initHeroVideo } from "./components/hero-video";
import { initInViewAnimations } from "./components/inview-animate";
import { initStoryCarousel } from "./components/story-carousel";
import { initEmailSignup } from "./components/email-signup"; 
import { initPriorityMessages } from "./components/priority-messages";
import { initScrollState } from "./components/scroll-state";
import { initNavigationBehavior } from "./components/navigation-behavior";
import "./components/messenger-loader";
import { blockModalFocus } from "./components/bootstrap-helpers";
import initPortStepTabs from "./components/port-steptabs";
import { initPageUpdateNotificationWidget } from './components/vue/page-update-notification-widget/page-update-notification-widget';

function domReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
}

domReady(() => {
    initMegaMenu();
    initInViewAnimations();
    initEmailSignup();
    initPriorityMessages();
    initScrollState();
    initNavigationBehavior();
    blockModalFocus();
    initPortStepTabs();

    // these are page specific, but sort of ubiquitously used and
    // fail fast if the dom elements aren't found, so are pretty safe to keep global
    initHeroVideo();
    initStoryCarousel();
    initPageUpdateNotificationWidget();
});
